module.exports = __webpack_public_path__ + "media/images/games/k2gender/footballplayer-d268032fbe827d7a17c2862bec5a378c.png";